// "use client";
// import { StyledWrapper } from '@/components/Home/contentSect/styles';

// const Growth = ({ Data }: any) => {
//     // const [Data, setData] = useState<any>(); // Initial state should be null
//     // const { apidata } = Useapi(); // Destructure apidata from the context
//     console.log(Data,)
//     return (
//         <div className="w-full">
//             <div className="flex flex-wrap w-full">
//             {Data?.card?.map((elem: any, index: number) => (
//                     <div
//                         key={index}
//                         className={`w-full ${index % 2 == 0 ? 'sm:border-r-2 ' : 'border-r-0'} ${index < Data.length - 2 ? 'border-b-2 ' : ' border-b-2 sm:border-b-0'} md:w-1/2 px-4 border-blue flex`}>
//                         <div className="w-full flex flex-col justify-between py-3 sm:py-6  rounded-md ">
//                             <StyledWrapper>
//                                 <div
//                                     className="text-homegrey text-center lg:text-left"
//                                     dangerouslySetInnerHTML={{ __html: elem?.description }}
//                                 ></div>
//                             </StyledWrapper>
//                         </div>
//                     </div>
//                 ))}
//             </div>
//         </div>);
// };
// export default Growth;

"use client";
import { useState, useEffect, useMemo } from "react";
import { LuExternalLink } from "react-icons/lu";
import { FaAngleDown } from "react-icons/fa6";
import { motion, AnimatePresence } from "framer-motion";

type ServiceItem = {
  name: string;
  url: string;
};

type ParsedService = {
  id: string;
  title: string;
  description: string;
  services: ServiceItem[];
};

type GrowthProps = {
  Data: {
    card: {
      service_name: string;
      description: string;
    }[];
  };
};

const Growth = ({ Data }: GrowthProps) => {
    const [activeTab, setActiveTab] = useState<string | null>(null);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => {
          setIsMobile(window.innerWidth < 768); // Tailwind's md breakpoint
        };
        
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
      }, []);

  const servicesData = useMemo(() => {
    if (!Data?.card) return [];

    return Data.card.map((item) => {
      const id = item.service_name
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");

      let description = "";
      let services: ServiceItem[] = [];

      if (typeof window !== "undefined") {
        const parser = new DOMParser();
        const doc = parser.parseFromString(item.description, "text/html");
        description = doc.querySelector("p")?.textContent ?? "";
        services = Array.from(doc.querySelectorAll("a")).map((a) => ({
          name: a.textContent ?? "",
          url: a.getAttribute("href") ?? "#",
        }));
      }

      return {
        id,
        title: item.service_name,
        description,
        services,
      };
    });
  }, [Data]);

  useEffect(() => {
    if (servicesData.length > 0 && !isMobile && activeTab === null) {
      setActiveTab(servicesData[0].id);
    }
  }, [servicesData, isMobile, activeTab]);



  const activeService = servicesData.find((service) => service.id === activeTab);

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  return (
    <div className="w-full">
      {/* Mobile View */}
      <div className="md:hidden space-y-4 h-full">
        {servicesData.map((service) => (
          <div key={service.id} className="w-full">
            <motion.button
              whileTap={{ scale: 0.98 }}
              onClick={() =>
                setActiveTab(activeTab === service.id ? "" : service.id)
              }
              className={`w-full text-left px-6 py-3 flex justify-between items-center rounded-xl transition-colors ${
                activeTab === service.id
                  ? "bg-[#EF1649] text-white"
                  : "bg-white shadow-xl text-[#EF1649]"
              }`}
            >
              <h3 className="font-medium">{service.title}</h3>
              <motion.div
                animate={{ rotate: activeTab === service.id ? 180 : 0 }}
                transition={{ duration: 0.3 }}
              >
                <FaAngleDown />
              </motion.div>
            </motion.button>

            <AnimatePresence>
              {activeTab === service.id && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.3 }}
                  className="overflow-hidden"
                >
                  <div className="w-full bg-white p-6 rounded-lg shadow-lg mt-1">
                    <motion.p
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      transition={{ delay: 0.2 }}
                      className="text-[#0A0A0A] border-b-2 border-[#1090D0] leading-6 text-[1rem] font-semibold mb-6"
                    >
                      {service.description}
                    </motion.p>
                    <motion.div
                      variants={containerVariants}
                      initial="hidden"
                      animate="show"
                      className="space-y-1"
                    >
                      {service.services.map((item, index) => (
                        <motion.a
                          key={index}
                          variants={itemVariants}
                          href={item.url}
                          className="group flex p-2 rounded-lg"
                        >
                          <span className="text-[#1090D0] text-sm flex items-center justify-start gap-2">
                            {item.name}
                            <LuExternalLink color="#EF1649" />
                          </span>
                        </motion.a>
                      ))}
                    </motion.div>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        ))}
      </div>

      {/* Desktop View */}
      <div className="hidden md:flex flex-col md:flex-row gap-8">
        {/* Left Nav */}
        <div className="w-full md:w-1/3 lg:w-2/3 space-y-2 h-full">
          {servicesData.map((service) => (
            <motion.button
              key={service.id}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={() => setActiveTab(service.id)}
              className={`w-full text-left px-6 md:py-[0.7rem] lg:py-[0.5rem] rounded-full transition-colors ${
                activeTab === service.id
                  ? "bg-[#EF1649] text-white shadow-xl"
                  : "bg-white shadow-xl text-[#EF1649]"
              }`}
            >
              <h3 className="font-semibold text-center lg:!text-[1.2rem] md:text-[1rem]">{service.title}</h3>
            </motion.button>
          ))}
        </div>

        {/* Right Content */}
        <div className="w-full md:w-2/3 lg:w-3/4 bg-white p-6 rounded-lg shadow-lg">
          <AnimatePresence mode="wait">
            {activeService && (
              <motion.div
                key={activeTab}
                initial={{ opacity: 0, x: 0 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 0 }}
                transition={{ duration: 0.3 }}
                 className="h-full flex flex-col"
              >
                <motion.p className="text-[#0A0A0A] text-lg border-b-2 border-[#1090D0] font-semibold mb-6">
                  {activeService.description}
                </motion.p>

                <motion.div
                  variants={containerVariants}
                  initial="hidden"
                  animate="show"
                >
                  {activeService.services.map((service, index) => (
                    <motion.a
                      key={index}
                      variants={itemVariants}
                      href={service.url}
                      className="group flex py-3 rounded-lg"
                    >
                      <span className="text-[#1090D0] flex items-center lg:text-[1rem] md:text-sm justify-start gap-2">
                        {service.name}
                        <LuExternalLink color="#EF1649" />
                      </span>
                    </motion.a>
                  ))}
                </motion.div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
};

export default Growth;
